import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { UsersService } from '../services/api/internal/users.service';

export function initialGuard(): CanActivateFn {
  return (route: ActivatedRouteSnapshot) => {
    const usersService = inject(UsersService);
    const router: Router = inject(Router);

    usersService.startSession();

    return router.parseUrl(sanitizeAfterLoginTarget(route.queryParamMap.get('target')));
  };
}

function sanitizeAfterLoginTarget(target: string | null): string {
  if (!target || !target.startsWith('/') || target.startsWith('//') || target.startsWith('/after-login')) {
    return '/';
  }

  return target;
}
